import AppFlowActions from '../../constants';
import initialState from './initialState';

const loading = (state = initialState.isLoading, action) => {
  switch (action.type) {
    case AppFlowActions.DISPLAY_LOADING: {
      return action.data;
    }
    default: {
      return state;
    }
  }
};

export default loading;
